export default __webpack_public_path__ + "static/media/Indexx Token.fbb9c6bd.png";